<button
  [id]="'favoriteButton' + record?.id"
  *ngIf="!alreadyInFavorites && !isMoreOption"
  class="only-icon icon-not-menu"
  mat-flat-button
  appStopPropagation
  (click)="addToFavorites()"
  [attr.aria-label]="'tooltip.addToFavorites' | translate"
  [opacTooltip]="'tooltip.addToFavorites' | translate">
  <span class="odilo-icon" aria-hidden="true">favorite</span>
</button>

<button
  *ngIf="alreadyInFavorites && !isMoreOption"
  class="only-icon is-favorite icon-not-menu"
  mat-flat-button
  appStopPropagation
  (click)="removeFromFavorites()"
  [attr.aria-label]="'tooltip.removeFromFavorites' | translate"
  [opacTooltip]="'tooltip.removeFromFavorites' | translate">
  <span class="odilo-icon" aria-hidden="true">favorite_black</span>
</button>
  <button
  [id]="'favoriteButton' + record?.id"
  *ngIf="!alreadyInFavorites && isMoreOption"
  class="only-icon"
  mat-menu-item
  (click)="addToFavorites()">
  <span class="odilo-icon" aria-hidden="true">favorite</span>
  {{ 'tooltip.addToFavorites' | translate }}
</button>
<button
  *ngIf="alreadyInFavorites && isMoreOption"
  class="only-icon is-favorite"
  mat-menu-item
  (click)="removeFromFavorites()">
  <span class="odilo-icon" aria-hidden="true">favorite_black</span>{{ 'tooltip.removeFromFavorites' | translate }}
</button>
